export default __webpack_public_path__ + "static/media/tasks.32189ded.svg";